import genesis from "./genesis.json";

const config= {
    GENESIS: genesis,
    BASE_URL: "https://goerli-proposer.thehubbleproject.net"
}

export default config;